<template>
    <div class="bg-theme-fa rounded-xl px-5 flex flex-col justify-between py-10 shadow-lg">
        <h4 class="text-3xl text-theme-blue font-bold">{{item.name}}</h4>
        <dl class="my-5">
            <dt class="text-theme-sky mt-5 font-light flex">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                Ubicación</dt>
            <dl class="font-semibold">{{item.address}}</dl>
            <dt class="text-theme-sky mt-5 font-light flex">
                <Icons name="envelope" class="w-6"/>
                E-Mail</dt>
            <dl class="font-semibold break-words">{{item.email}}</dl>
        </dl>
        <router-link :to="{name:'BiblioDetail', params: {id:item.id}}"><div class="">
            <div class="btn-readmore w-4/5 text-white bg-theme-blue mx-auto rounded-lg text-center py-3 px-1 text-sm self">
                MÁS INFORMACIÓN
            </div>
        </div></router-link>

    </div>
</template>

<script>

import Icons from '@/components/Icons.vue'  

export default {

    props: ['item'],
    components: {
        Icons
    },    

}
</script>
